<template>
  <div style="display: inline">
    <template
      v-if="
        userCards &&
        userCards.length !== 0 &&
        planStatus !== 'trialing' &&
        !forcePaymentError
      "
    >
      <span
        class="card-warnings__card-container--text"
        v-html="$t('message.navDrawer.forcePayment.defaultError1')"
      ></span>
      <img
        v-if="
          userCards && userCards.length !== 0 && !!getDefaultCard.brand_logo
        "
        :src="getDefaultCard.brand_logo"
        width="25"
        class="rounded card-image"
      />
      <b v-if="getDefaultCard.brand && getDefaultCard.last4">
        {{ getDefaultCard.brand }}-{{ getDefaultCard.last4 }}
      </b>
      <span
        class="card-warnings__card-container--text"
        v-html="$t('message.navDrawer.forcePayment.defaultError2')"
      ></span>
    </template>
    <template
      v-else-if="
        userCards &&
        userCards.length !== 0 &&
        planStatus !== 'trialing' &&
        forcePaymentError &&
        !forcePaymentErrorMessage
      "
    >
      <span
        class="card-warnings__card-container--text"
        v-html="$t('message.navDrawer.forcePayment.deniedError1')"
      ></span>
      <img
        v-if="
          userCards && userCards.length !== 0 && !!getDefaultCard.brand_logo
        "
        :src="getDefaultCard.brand_logo"
        width="25"
        class="rounded"
        style="
          vertical-align: text-bottom;
          margin-left: 5px;
          margin-right: 2px;
          max-height: 100%;
          height: 100%;
          display: inline;
        "
      />
      <b v-if="getDefaultCard.brand && getDefaultCard.last4">
        {{ getDefaultCard.brand }}-{{ getDefaultCard.last4 }}.
      </b>
      <span
        class="card-warnings__card-container--text"
        v-html="$t('message.navDrawer.forcePayment.deniedError2')"
      ></span>
    </template>
    <span
      v-else-if="userCards && userCards.length === 0"
      v-html="$t('message.navDrawer.userWarnings.doNotHaveCards')"
    >
    </span>
    <template v-else-if="forcePaymentError">
      <span v-html="forcePaymentErrorMessage"></span>
    </template>
  </div>
</template>
<script>
import planApi from '@/services/planApi'
import i18n from '@/translations/lang'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'CardWarning',
  data: () => ({
    forcePaymentLoading: false,
    forcePaymentError: false,
    forcePaymentMessage: '',
    userCards: [],
    cardsImages: {
      mastercard:
        'https://js.stripe.com/v3/fingerprinted/img/mastercard-4d8844094130711885b5e41b28c9848f.svg',
      visa: 'https://js.stripe.com/v3/fingerprinted/img/visa-729c05c240c4bdb47b03ac81d9945bfe.svg',
      elo: 'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
      american_express:
        'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
    },
  }),
  props: {
    planStatus: {
      required: true,
    },
  },
  computed: {
    ...mapState('user', {
      userSubscription: (state) => state.userPlanInfo.subscription,
    }),
    forcePaymentErrorMessage() {
      if (this.forcePaymentError) {
        this.UPDATE_ACTION_BUTTON_TYPE('oneButton')
        if (this.forcePaymentMessage === 'Your card has expired.') {
          return i18n.t('message.navDrawer.forcePayment.cardExpired')
        } else if (
          this.forcePaymentMessage === 'Your card has insufficient funds.'
        ) {
          return i18n.t('message.navDrawer.forcePayment.insufficientFunds')
        } else if (
          this.forcePaymentMessage ===
          'Invoices with pending payments waiting to clear cannot be paid, voided, or marked uncollectible.'
        ) {
          this.UPDATE_ACTION_BUTTON_TYPE('none')
          return i18n.t('message.navDrawer.forcePayment.paymentPending')
        }
      }
      return false
    },
    getDefaultCard() {
      if (this.userCards.length !== 0) {
        const defaultCard =
          this.userCards.filter((el) => el.default === true)[0] ||
          this.userCards[0]
        if (defaultCard.brand) {
          defaultCard.brand_logo = this.cardsImages[defaultCard.brand]
          defaultCard.brand =
            defaultCard.brand.charAt(0).toUpperCase() +
            defaultCard.brand.slice(1)
        }
        return defaultCard
      } else {
        return this.userCards
      }
    },
  },
  async mounted() {
    this.$root.$on('tryCardAgain', this.tryPaymentAgain)
    await this.loadCards()
    this.UPDATE_WARNING_CARDS_LOADED(true)
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapMutations('dashboard', [
      'UPDATE_ACTION_BUTTON_TYPE',
      'UPDATE_WARNING_CARDS_LOADED',
    ]),
    handleStartCompletPlan() {
      this.$root.$emit('ModalResetBillingCycle')
    },
    async loadCards() {
      try {
        const { data } = await planApi.getCards()
        this.userCards = data.sources
        if (
          this.userCards.length &&
          this.planStatus !== 'trialing' &&
          !this.forcePaymentError
        ) {
          this.UPDATE_ACTION_BUTTON_TYPE('twoButtons')
        }
        this.$root.$emit('checkWarningTextSize')
      } catch (err) {
        console.error(err)
      }
    },
    async tryPaymentAgain() {
      try {
        if (this.userSubscription) {
          this.forcePaymentLoading = true
          this.forcePaymentError = false
          let ret = await planApi.forcePayment(
            this.userSubscription.latest_invoice_id
          )
          this.forcePaymentLoading = false
          this.$root.$emit('refreshUserPlan')
          this.handleSnackbar(
            this.$t('message.navDrawer.forcePayment.successMessage')
          )
          return ret
        }
      } catch (error) {
        this.forcePaymentMessage = error.response.data.errMsg.error
        this.forcePaymentLoading = false
        this.forcePaymentError = true
        console.error('error', error)
      }
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.navDrawer.successMessage')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
      })
    },
  },
}
</script>

<style scoped>
.card-image {
  vertical-align: text-bottom;
  margin-left: 5px;
  margin-right: 2px;
  max-height: 100%;
  height: 100%;
  display: inline;
}
</style>
